export interface CalculatedLine {
  quantity: number;
  unitPriceCents: number;
  taxRateBps: number;
  subtotalCents: number;
  taxCents: number;
  totalCents: number;
}

export function calculateLine(
  quantity: number,
  unitPriceCents: number,
  taxRateBps: number
): CalculatedLine {
  if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100_000) {
    throw new Error("Quantity must be a whole number between 1 and 100,000.");
  }
  if (!Number.isInteger(unitPriceCents) || unitPriceCents < 0) {
    throw new Error("Unit price must be a non-negative integer number of cents.");
  }
  if (!Number.isInteger(taxRateBps) || taxRateBps < 0 || taxRateBps > 10_000) {
    throw new Error("Tax rate must be between 0 and 100 percent.");
  }

  const subtotalCents = quantity * unitPriceCents;
  const taxCents = Math.round((subtotalCents * taxRateBps) / 10_000);
  return {
    quantity,
    unitPriceCents,
    taxRateBps,
    subtotalCents,
    taxCents,
    totalCents: subtotalCents + taxCents
  };
}

export function formatMoney(cents: number, currency = "CAD"): string {
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency,
    minimumFractionDigits: 2
  }).format(cents / 100);
}

export function percentageOfCents(amountCents: number, rateBps: number): number {
  if (!Number.isInteger(amountCents) || amountCents < 0) {
    throw new Error("Amount must be a non-negative integer number of cents.");
  }
  if (!Number.isInteger(rateBps) || rateBps < 0 || rateBps > 10_000) {
    throw new Error("Rate must be between 0 and 100 percent.");
  }
  return Math.round((amountCents * rateBps) / 10_000);
}
